import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "price-and-button d-flex flex-column" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between w-100 total-price-row" }
const _hoisted_3 = { class: "heading mb-1" }


import Price from '@/components/common/Price.vue'
import { BookingSummary } from '@/services/BookingService.interface'
import ReserveActionsButton from '@/components/common/ReserveActionsButton.vue'
import { useBookingFunnelActions } from '@/composables/useBookingFunnelActions'
import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceAndQuoteButton',
  props: {
  buttonText: {
    type: String,
    required: true,
  },
  booking: {
    type: Object as () => BookingSummary,
    required: true,
  },
  /** Panel mobile: CTA is in StickyBar to avoid duplicate Réserver. */
  hideActionButton: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const { showReserveButton, showPayBalanceButton } = useBookingFunnelActions(
  () => props.booking
)
const { payActionLabel } = useBookingFunnelNavigation(() => props.booking)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('reservations.total')), 1),
      _createVNode(Price, {
        price: __props.booking.sellingPrice,
        class: "heading"
      }, null, 8, ["price"])
    ]),
    (_unref(showReserveButton) && !__props.hideActionButton)
      ? (_openBlock(), _createBlock(ReserveActionsButton, {
          key: 0,
          class: "mt-3 reserve-actions-wrapper",
          booking: __props.booking,
          "default-label": __props.buttonText,
          "button-class": "reserve-button"
        }, null, 8, ["booking", "default-label"]))
      : (_unref(showPayBalanceButton) && !__props.hideActionButton)
        ? (_openBlock(), _createBlock(ReserveActionsButton, {
            key: 1,
            class: "mt-3 reserve-actions-wrapper",
            booking: __props.booking,
            "default-label": _unref(payActionLabel),
            "button-class": "reserve-button"
          }, null, 8, ["booking", "default-label"]))
        : _createCommentVNode("", true)
  ]))
}
}

})